import { render, staticRenderFns } from "./LicitacaoVisualizacaoSimularProposta.vue?vue&type=template&id=0210e8a6&"
import script from "./LicitacaoVisualizacaoSimularProposta.vue?vue&type=script&lang=js&"
export * from "./LicitacaoVisualizacaoSimularProposta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports